export const PermissionLocker = {
    PUT: "change_locker",
    EXPORT: "can_export_locker",
    VIEW: "view_locker",
};